<div class="circle d-inline-flex align-items-center justify-content-center" [class]="classNames()">
  <ng-content></ng-content>
</div>
